// extracted by mini-css-extract-plugin
export default {"pageBg":"EducationPage_pageBg__j5zSL"};